<template>
  <transition name="slide-fade">
    <div
      class="charactersSprite"
      :class="{vertical: isTemplateV(), template: isTemplate()}"
      v-if="boxData.judgeBox"
      :style="{
      'top': boxData.fix.y+'px',
      'left': boxData.fix.x + 'px',
      'z-index': boxData.Zindex,
    }"
      @mousedown="stopDocument($event)"
    >
      <div
        :style="{
        'width': boxSize.width + 'px',
        'min-height' : boxSize.height+ 'px',
      }"
        @mouseleave="hoverClose()"
        @mouseenter="setTiemOut()"
      >
        <span
          :style="{
          'top': this.dataMsg[this.boxDataName].posy+35+'px',
          'left':boxData.fix.x -5 + 'px'
        }"
        ></span>

        <div
          class="itemTitle"
          v-if="itemTitle"
        >
          <span>{{getShortTitle(itemTitle)}}</span>
          <a
            v-if="isTemplate()"
            :href="detailUrl"
            target="_blank"
          >
            <span class="detail">查看详情</span>
          </a>
        </div>

        <!--'characters'-->
        <div
          class="iteamlottie"
          v-if="itemDataType == 'lottie'"
          v-for="(item, index) in charactersData"
          :key="item.id"
          @click="addSprite(item)"
          @mouseenter="loadLottie(item, {index: index , id:'characterssprite_'+index}, true) "
          @mouseleave="loadLottie(item, {index: index , id:'characterssprite_'+index}, false)"
        >
          <img
            :src="$handleAssetsUrl(item.thumbnailUrl)"
            width="auto"
            height="100%"
            @loadstart="toggleError(false)"
            @error="toggleError(true)"
          />
          <div
            class="Clottie"
            :lottiedom="'characterssprite_'+index"
          ></div>
          <span class="title">{{item.title}}</span>
        </div>

        <!--'矢量动图'-->
        <div
          class="vectorLottie"
          v-if="itemDataType == 'vectorLottie'"
        >
          <div
            class="vectorLottieContainer"
            ref="vectorLottieDom"
          ></div>
          <span
            v-if="boxName === 'personal' "
            class="delBtn"
            @click="cancelScenes()"
          >
            <span class="el-icon-delete"></span>
          </span>
        </div>

        <!--'img, gif'-->
        <div
          class="iteamImg"
          v-if="itemDataType == 'img' || itemDataType == 'gif'"
        >
          <img
            :src="handleImgUrl(this.boxData.data.url, this.boxData.data)"
            width="auto"
            height="100%"
            @load="onImgLoad($event)"
            @loadstart="toggleError(false)"
            @error="toggleError(true)"
          />
          <span
            v-if="boxName === 'personal'"
            class="delBtn"
            @click="cancelScenes()"
          >
            <span class="el-icon-delete"></span>
          </span>
        </div>

        <!--'video'-->
        <div
          class="iteamVideo"
          v-if="itemDataType == 'video'"
        >
          <video
            width="auto"
            height="100%"
            ref="personalVideo"
            preload="preload"
            autoplay="autoplay"
            loop="loop"
            :muted="!isTemplate()"
            :src="this.$handleAssetsUrl(isTemplate() ? this.boxData.data.url.replace('.mp4','nail.mp4') : this.boxData.data.url)"
            @loadstart="toggleError(false)"
            @error="toggleError(true)"
          >您的浏览器不支持 video 标签。</video>

          <div
            class="videoCtrl"
            :style="{
              'width': boxSize.width - 4 + 'px',
              'height' : boxSize.height - 4+ 'px',
            }"
          >
            <div class="ctrtlBtn">
              <span
                class="delBtn"
                style="line-height: 50px;"
                @click="playVideo()"
              >
                <span
                  v-if="!this.videoDom.player"
                  class="el-icon-caret-right"
                  style="font-size: 25px;"
                ></span>

                <span
                  v-if="this.videoDom.player"
                  class="playerIcon"
                  style="font-size: 25px; position: relative;"
                ></span>
              </span>

              <span
                v-if="boxName === 'personal'"
                class="delBtn"
                @click="cancelScenes()"
              >
                <span class="el-icon-delete"></span>
              </span>
            </div>

            <div
              class="timeLine"
              :style="{
                'width': boxSize.width - 2 -20 + 'px',
              }"
            >
              <div
                class="durationTime"
              >{{resultFormat(videoDom.currentTime)}} / {{resultFormat(videoDom.duration)}}</div>

              <template v-if="isTemplate()">
                <div
                  class="progresBar short"
                  :style="{width: '280px'}"
                >
                  <span
                    class="bar"
                    :style="{
                      'width':  ((videoDom.currentTime/videoDom.duration*280).toFixed(0) || 4) + 'px',
                    }"
                  ></span>
                </div>
                <div
                  class="vol"
                  :class="{off: !isSound}"
                  @click="toggleSound"
                ></div>
              </template>

              <div
                class="progresBar"
                v-else
              >
                <span
                  class="bar"
                  :style="{
                    'width':  ((videoDom.currentTime/videoDom.duration*166).toFixed(0) || 4) + 'px',
                  }"
                ></span>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="boxName === 'personal' && (SpriteOperation !== 'swap') && (BgOperation !== 'swap') && ( itemDataType == 'video' || itemDataType == 'img')"
          class="settingBtn"
        >
          <div
            class="Sbtn"
            @click="
            settingScenesBg(itemData);
            $analysis('my_resource,click_preview_setbg,我的资源_视频_预览视频_为背景')
          "
          >
            <span class="modifyBg"></span>设置为背景
          </div>

          <div
            class="Sbtn"
            @click="
            slidAddSprites(itemData);
            $analysis('my_resource,click_preview_setmaterial,我的资源_视频_预览视频_为素材')
          "
          >
            <span class="modifySprite"></span>设置为素材
          </div>
        </div>

        <!--'loading'-->
        <div
          class="loadingData"
          v-if="loadingData"
          :style="{
          'min-width': boxSize.width - 4 + 'px',
          'min-height' : boxSize.height - 4+ 'px',
        }"
          @mousedown="stopDocument($event)"
        >
          <span style="font-size: 16px;width: 280px;height: 36px;color: #333;text-align: left;" v-if="isLoadError">
            <!-- 该素材因内容违规,无法正常使用。请使用其他素材。 -->
            素材加载失败，请刷新重试。
            </span>
          <span v-else class="el-icon-loading"></span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import popupSecond from "../../mixins/popupSecond";

export default {
  mixins: [popupSecond],
  data () {
    return {
      boxDataName: "charactersSprite", // 弹窗名称
      loading: false,
      boxName: "",
      charactersData: [],
      setTime: false, // 事件判断
      timeout: false,
      lottiedata: null,
      resourceId: "",
      loadLottieSetTime: null,
      itemDataType: "lottie",
      boxSize: {
        width: 225,
        height: 200,
      },
      loadingData: true,
      videoDom: {
        dom: "",
        duration: 0,
        currentTime: 0,
        player: false,
      },
      itemTitle: "",
      itemData: null,
      isSound: false,
      location: window.location,
      isLoadError: false,
      detailUrl: ''
    };
  },
  watch: {
    "boxDatas.secondData": function (val, oldval) {
      // 判断打开关闭
      const vm = this;
      let num = Array.indexOf(this.boxDatas.secondData, this.boxDataName);
      this.boxData.judgeBox = num < 0 ? false : true; // 判断是否打开

      if (this.TOOL && this.boxData.judgeBox) {
        this.dataMsg[this.boxDataName]
        this.detailUrl = this.location.origin + "/templates/" + (this.dataMsg[this.boxDataName].data || {}).id;
        this.isLoadError = false;
        // 打开的操作
        this.itemData = null;
        this.loadingData = true;
        this.boxData.Zindex = (Object.keys(this.dataMsg || {}).length + 1) * 5;
        this.boxData.data = this.dataMsg[this.boxDataName].data;
        this.itemData = this.dataMsg[this.boxDataName].data;
        this.boxName = this.dataMsg[this.boxDataName].boxName;
        this.isSound = false;

        if (this.boxName == "template") {
          this.boxData.data.url = this.boxData.data.videoUrl;
          this.boxData.data.fileType = "template";
        }
        if (this.boxData.data) {
          switch (this.boxData.data.fileType) {
            case 6: // png/jpg/jpeg--形状
            case 11: // png/jpg/jpeg--文字
            case 18: // png/jpg/jpeg--图片
            case 19: // 图片
            case 1:
            case 3:
            case "png":
            case "jpg":
            case "jpeg":
              this.boxSize.width = 301;
              this.boxSize.height = 176;
              this.boxData.fix.x = this.dataMsg[this.boxDataName].posx + 130;
              this.boxData.fix.y = this.dataMsg[this.boxDataName].posy - 39;
              this.itemDataType = "img";
              break;
            case 34:
            case 32:
            case "gif":
              this.boxSize.width = 301;
              this.boxSize.height = 176;
              this.boxData.fix.x = this.dataMsg[this.boxDataName].posx + 130;
              this.boxData.fix.y = this.dataMsg[this.boxDataName].posy - 39;
              this.itemDataType = "gif";
              break;
            case 5: // lottie--道具
            case 8: // lottie--形状
            case 10: // lottie--角色
              this.boxSize.width = 225;
              this.boxSize.height = 200;
              this.boxData.fix.x = this.dataMsg[this.boxDataName].posx + 80;
              this.boxData.fix.y = this.dataMsg[this.boxDataName].posy - 50;
              this.itemDataType = "lottie";
              if (this.boxData.data && this.boxData.data.judgeTytpe) {
                this.getCharacters(this.boxData.data.judgeTytpe);
              } else {
                this.getCharacters(this.dataMsg[this.boxDataName].boxName);
              }
              break;
            case 47: // lottie--矢量动图
              this.boxSize.width = 301;
              this.boxSize.height = 176;
              this.boxData.fix.x = this.dataMsg[this.boxDataName].posx + 130;
              this.boxData.fix.y = this.dataMsg[this.boxDataName].posy - 39;
              this.itemDataType = "vectorLottie";
              this.loadVectorLottie(this.boxData.data, true);
              break;
            case 25:
            case 26:
            case 27:
            case "template":
              if (this.boxData.data.fileType == "template") {
                this.itemTitle = this.boxData.data.title;
              }
              this.boxSize.width = 301;
              this.boxSize.height = 176;
              this.boxData.fix.x = this.dataMsg[this.boxDataName].posx + 130;
              this.boxData.fix.y = this.dataMsg[this.boxDataName].posy - 39;
              this.itemDataType = "video";

              let timeoutid = setTimeout(() => {
                this.videoDom.dom = this.$refs.personalVideo;
                if (!this.videoDom.dom) {
                  return;
                }
                this.videoDom.dom.volume = 0;

                this.videoDom.dom.addEventListener(
                  "timeupdate",
                  () => {
                    if (this.loadingData) {
                      this.videoDom.dom.currentTime = 0;
                      this.loadingData = false;
                      this.videoDom.player = true;
                    }

                    if (
                      this.videoDom.dom.currentTime >= this.videoDom.duration &&
                      this.videoDom.player
                    ) {
                      this.videoDom.dom.pause();
                      this.videoDom.dom.currentTime = 0;
                    }

                    this.videoDom.duration = this.videoDom.dom.duration;
                    this.videoDom.currentTime = this.videoDom.dom.currentTime;
                  },
                  false
                );

                clearTimeout(timeoutid);
              }, 500);
              break;
            default:
              if (!this.boxData.data.fileType) {
                this.boxSize.width = 301;
                this.boxSize.height = 176;
                this.boxData.fix.x = this.dataMsg[this.boxDataName].posx + 130;
                this.boxData.fix.y = this.dataMsg[this.boxDataName].posy - 39;
                this.itemDataType = "img";
              }
          }

          if (this.boxData.fix.y + this.boxSize.height > window.innerHeight) {
            this.boxData.fix.y = window.innerHeight - this.boxSize.height - 50;
          }
          if (
            this.isTemplate() &&
            this.boxData.fix.y + this.boxSize.height + 120 > window.innerHeight
          ) {
            this.boxData.fix.y = window.innerHeight - this.boxSize.height - 50;
            this.boxData.fix.y -= 120;
          }
        }
        // console.log(this.boxData.data, this.boxData.fix, '=======')
        this.setTime = true;
      } else {
        this.loadingData = false;
        this.itemTitle = "";
      }
    },
    isSound (val) {
      const vm = this;
      if (vm.isTemplate() && vm.$refs.personalVideo) {
        vm.$refs.personalVideo.muted = false;
        vm.$refs.personalVideo.volume = vm.isSound ? 0.7 : 0;
      }
    },
  },
  props: [],
  computed: {
    ...mapGetters([
      "S_SearchData",
      "SpriteOperation",
      "SelectSprites_Msg",
      "SpriteBeforeSwap",
      "SelectScenes_Msg",
      "BgOperation",
      "UserEquity",
    ]),
  },
  mounted () {
    this.$bus.on("setTimeOut_vue", (data) => {
      if (data.name === "proviewIremData") {
        this.hoverClose();
      }
    });
    this.$bus.on("windowMousedown_vue", (data) => {
      if (
        this.TOOL &&
        this.boxData.judgeBox &&
        this.boxData.data &&
        this.boxData.data.id !== data.data.id
      ) {
        // 打开的操作
        this.close();
        this.charactersData = [];
      }
    });
    this.$bus.on("itemPreview_vue", (data) => {
      if (this.boxData.judgeBox) {
        // 打开的操作
        if (this.boxData.data.id === data.data.id) {
          this.setTiemOut();
        } else {
          this.setTiemAction();
        }
      } else {
        this.setTiemAction();
      }
    });
  },
  methods: {
    toggleError (flag) {
      this.isLoadError = flag;
    },
    getCharacters (id) {
      // 获取收藏元素具体信息
      let data = {
        type: this.S_SearchData[id].resourceType,
        id: this.boxData.data.id,
      };
      this.loading = true;
      this.$http
        .get("/api/common/material", {
          params: data,
        })
        .then((res) => {
          if (this.boxData.data.id === res.data.data.id) {
            this.loadingData = false;
            this.itemDataType = "lottie";
            this.charactersData = res.data.data.action;
            this.itemTitle = res.data.data.title;
            // 角色系列id,与角色动作id有区别，记录到toJson的是角色动作id
            this.resourceId = res.data.data.id;
            this.loading = false;
          }
        });
    },
    addSprite (data) {
      // 添加角色
      if (this.SpriteOperation === "swap") {
        this.swapSprite(data);
        return;
      }
      this.TOOL.addSprite(
        "Lottie",
        {
          lottieOptions: {
            path: "https://resources.laihua.com/" + data.url,
            loop: 4,
            autoplay: true, // 控制播放
          },
          resourceId: data.id,
          characterId: this.resourceId,
          fileType: data.fileType, // 资源type
        },
        null,
        true
      );
    },
    swapSprite (data) {
      let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;
      this.TOOL.swapSprite(
        {
          sprite,
          typeForAdd: "Lottie",
          optionForAdd: {
            lottieOptions: {
              path: "https://resources.laihua.com/" + data.url,
              loop: 4,
              autoplay: true, // 控制播放
            },
            resourceId: data.id,
            characterId: this.resourceId,
            fileType: data.fileType, // 资源type
          },
        },
        true
      );
    },
    loadVectorLottie (data, judge) {
      this.loadingData = false;
      if (this.loadLottieSetTime) {
        clearTimeout(this.loadLottieSetTime);
      }
      if (judge) {
        this.loadLottieSetTime = setTimeout(() => {
          //let domtit = "div[lottiedom='"+ dom.id +"']";
          let lottiedom = this.$refs.vectorLottieDom;
          //console.log(lottiedom)
          if (lottiedom) {
            let option = {
              container: lottiedom,
              renderer: "svg",
              loop: true,
              autoplay: false,
              path: "https://resources.laihua.com/" + data.url,
            };
            this.lottiedata = lottie.loadAnimation(option);
            this.lottiedata.play();
          }
          clearTimeout(this.loadLottieSetTime);
        }, 100);
      } else {
        if (this.lottiedata) {
          this.lottiedata.stop();
          this.lottiedata.destroy();
          this.lottiedata = null;
        }
      }
    },
    loadLottie (data, dom, judge) {
      // 加载lottie
      if (this.loadLottieSetTime) {
        clearTimeout(this.loadLottieSetTime);
      }
      if (judge) {
        this.loadLottieSetTime = setTimeout(() => {
          let domtit = "div[lottiedom='" + dom.id + "']";
          let lottiedom = $(domtit);
          if (lottiedom.length) {
            let option = {
              container: lottiedom[0],
              renderer: "svg",
              loop: true,
              autoplay: false,
              path: "https://resources.laihua.com/" + data.url,
            };
            this.lottiedata = lottie.loadAnimation(option);
            this.lottiedata.play();
          }
          clearTimeout(this.loadLottieSetTime);
        }, 100);
      } else {
        if (this.lottiedata) {
          this.lottiedata.stop();
          this.lottiedata.destroy();
          this.lottiedata = null;
        }
      }
    },
    cancelScenes (id) {
      // 取消收藏单个元素
      let data = {
        id: id,
      },
        urlData = this.utlData();

      this.$http
        .delete("/api/user/" + urlData + "/" + this.boxData.data.id, data) // 收藏scenes
        .then((resScenes) => {
          let itemBox = "pic";
          switch (this.itemDataType) {
            case "video":
              itemBox = "video";
              break;
            case "scene":
              itemBox = "scene";
              break;
            case "img":
              itemBox = "pic";
              break;
            case "gif":
              itemBox = "gif";
              break;
            case "music":
              itemBox = "music";
              break;
            case "musicType":
              itemBox = "musicType";
              break;
          }
          this.$bus.emit("modifyUserItem_del_vue", {
            type: itemBox,
            boxName: this.boxName,
          });
        })
        .catch((Serror) => {
          console.log(Serror, "失败");
        });
      this.close();
    },
    utlData () {
      // 不同盒子的数据改变
      let urlData = "";

      switch (this.itemDataType) {
        case "video":
          urlData = "video";
          break;
        case "scene":
          urlData = "scene";
          break;
        case "img":
        case "gif":
        case "vectorLottie": //矢量动图
          urlData = "pic";
          break;
        case "music":
        case "musicType":
          urlData = "music";
          break;
      }
      return urlData;
    },
    playVideo () {
      // 播放视频
      if (this.videoDom.dom) {
        if (this.videoDom.dom.paused) {
          this.videoDom.dom.play();
          this.videoDom.player = true;
        } else {
          this.videoDom.dom.pause();
          this.videoDom.player = false;
        }
      }
    },
    setTiemAction () {
      if (this.setTime) {
        if (this.itemDataType == "vectorLottie") {
          this.loadVectorLottie({}, false); //预览窗口关闭时释放矢量动图lottie资源
        }
        this.close();
      }
    },
    setTiemOut () {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.setTime = false;
    },
    onImgLoad (ev) {
      this.loadingData = false;
    },
    hoverClose () {
      this.timeout = setTimeout(() => {
        this.setTime = true;
        this.setTiemAction();
        this.charactersData = [];
      }, 1000);
    },
    atOnceClose () {
      this.setTime = true;
      this.setTiemAction();
      this.charactersData = [];
    },
    stopDocument (e) {
      // 防止事件冒泡
      e.stopPropagation();
    },
    resultFormat (duration) {
      if (duration <= 0) return "00:00";
      if (!duration) return "--:--";
      var min = ~~(duration / 60);
      min = (min + "").length === 1 ? "0" + min : min;
      var sec = Math.round(duration % 60);
      sec = (sec + "").length === 1 ? "0" + sec : sec;
      min = min || "00";
      sec = sec || "00";
      return min + ":" + sec;
    },
    settingScenesBg (data) {
      // 设置分组背景
      let type =
        data.fileType === 25 || data.fileType === 26 ? "Video" : "Image";
      if (type == "Video") {
        this.$bus.emit("confirmAddVideo", {
          type: "bg", // 'bg' 'sprite'
          data: data,
        });
        return;
      }
      let sceneBgProps = this.SelectScenes_Msg.background;
      let bgOpts = {
        // 设置场景背景
        resourceId: data.id, // 背景资源id
        fileType: data.fileType, // 背景资源type
        type, // 背景类型 0:Color 1:Image 2:Video
        data: {
          // 颜色背景的数据
          url: data.url, // 颜色值,8位数
          blur: 0, // 高斯模糊
          opacity: 1, // 透明度
        },
        videoStartTime: 0,
        videoEndTime: parseInt(this.SelectScenes_Msg.duration / 1000),
        zoomActive: false,
      };

      if (this.BgOperation === "swap") {
        bgOpts.data = {
          ...sceneBgProps.data.data,
          url: data.url,
        };
        bgOpts.zoomActive = sceneBgProps.zoomActive;
        bgOpts.zoomOptions = sceneBgProps.zoomOptions;
      }

      this.SelectScenes_Msg.setBackground(bgOpts, null, true);

      if (this.BgOperation === "swap") {
        this.$store.commit("save_BgOperation", "add");
      } else {
        // this.SelectScenes_Msg.setBgZoom(false);
      }

      this.$bus.emit("judgeItemPayType_vue", {
        type: "bg",
        id: "BG-" + this.SelectScenes_Msg.id,
        option: {
          resourceId: data.id, // 背景资源id
          fileType: data.fileType, // 背景资源type
        },
        opHelper: {
          isSvip: false,
        },
        scenesId: this.SelectScenes_Msg.id,
      });
      this.$store.commit("del_vipSprites", {
        id: "BG-" + this.SelectScenes_Msg.id,
      });
      this.atOnceClose();
    },
    slidAddSprites (data) {
      // 添加元素
      let fileType = data.url.split(".")[1],
        itemType;

      switch (fileType) {
        case "PNG":
        case "png":
        case "JPG":
        case "jpg":
        case "JPEG":
        case "jpeg":
          itemType = "Image";
          break;
        case "svg":
        case "svg":
          itemType = "Svg";
          break;
        case "mp4":
        case "MP4":
          itemType = "video";
          break;
      }
      switch (itemType) {
        case "Image":
        case "Svg":
          if (this.SpriteOperation === "swap") {
            let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;

            this.TOOL.swapSprite(
              {
                sprite,
                typeForAdd: itemType,
                optionForAdd: {
                  url: data.url,
                  resourceId: data.id, // 资源id
                  fileType: isNaN(data.fileType) ? null : data.fileType, // 资源type
                },
              },
              true
            );
          } else {
            this.TOOL.addSprite(
              itemType,
              {
                url: data.url,
                resourceId: data.id,
                fileType: isNaN(data.fileType) ? null : data.fileType, // 资源type
                isLoop: false,
                effectCode: "FadeIn",
              },
              null,
              true
            );
          }
          break;
        case "video":
          this.$bus.emit("confirmAddVideo", {
            type: "sprite", // 'bg' 'sprite'
            data: data,
          });
          break;
      }
      this.atOnceClose();
    },
    toggleSound () {
      this.isSound = !this.isSound;
    },
    getLink () {
      return (
        this.location.origin + "/templates/" + this.dataMsg[this.boxDataName].id
      );
    },
    viewDetail () {
      let url = this.getLink();
      let link = document.createElement('a');
      link.href = url;
      link.click();
    },
    // isShowLink () {
    //   let hasPriceTag = this.itemData.payType && !this.UserEquity.exclusive
    //   let ret = !hasPriceTag;
    //   return ret;
    // }
    getShortTitle (str = "") {
      if (str.length > 13) {
        str = str.slice(0, 13) + "...";
      }
      return str;
    },
    isTemplate () {
      const vm = this;
      return vm.boxName === "template" || vm.itemData.fileType === "template";
    },
    isTemplateV () {
      const vm = this;
      return (
        (vm.boxName === "template" || vm.itemData.fileType === "template") &&
        vm.itemData.direction === 2
      );
    },
    handleImgUrl (url) {
      return this.$handleAssetsUrl(url);
    }
  },
  components: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.charactersSprite.template {
  & > div {
    width: 509px !important;
    min-height: 320px;
    padding-top: 16px;
    background-color: #fff;
    box-shadow: 0 0 8px 0 rgba(102, 111, 158, .23);
    border: solid 1px #dcdaf4;
  }
  & > div .iteamVideo {
    width: 100% !important;
    height: 276px !important;
  }

  & > div .videoCtrl {
    width: 100% !important;
    height: 100% !important;
  }
  & > div .videoCtrl:hover .timeLine {
    bottom: 0;
    width: 100% !important;
  }
  & > div .itemTitle {
    padding-bottom: 10px;
  }
  & > div .itemTitle > span {
    color: #474261;
  }
}
.charactersSprite {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 35;
  overflow: hidden;
  width: auto;
  min-height: 200px;
  &.vertical {
    // width: 192px;
    // height: 346px;
  }

   > div {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    width: 225px;
    min-height: 200px;
    padding: 10px;
    background: #fff;
    box-shadow: #d8dee9 0 0 5px 0;
    border: 1px solid #d8dee9;
    border-radius: 6px;

     > span {
      position: fixed;
      top: 0;
      left: -6px;
      width: 10px;
      height: 10px;
      background: #fff;
      border-bottom: 1px solid #d6d3d3;
      border-left: 1px solid #d6d3d3;
      transform: rotate(45deg);
    }

    .delBtn {
      display: inline-block;
      width: 40px;
      height: 40px;
      line-height: 40px;
      background: rgba(0, 0, 0, .5);
      border-radius: 100%;
      cursor: pointer;
      span {
        color: #fff;
        font-size: 17px;
      }
    }

    .videoCtrl {
      position: absolute;
      top: 2px;
      left: 2px;
      z-index: 100;
      width: 100%;
      height: 100%;
      border-radius: 6px;

      &:hover {
        .timeLine {
          opacity: 1;
        }
        .ctrtlBtn {
           > span {
            opacity: 1;
          }
        }
      }
      .ctrtlBtn {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 45px;
        left: 0;
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 120px;
        height: 40px;
        margin: auto;

         > span {
          transition: all .3s;
          opacity: 0;
        }
        .playerIcon {
          display: inline-block;
          width: 15px;
          height: 25px;

          &:after,
          &:before {
            content: "";
            position: absolute;
            top: 8px;
            left: 0;
            display: inline-block;
            width: 5px;
            height: 15px;
            background: #fff;
          }
          &:after {
            left: 10px;
          }
        }
      }

      .timeLine {
        position: absolute;
        bottom: 18px;
        left: -2px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 20px;
        padding: 0 5px;
        color: #fff;
        background-color: rgba(0, 0, 0, .5);
        opacity: 0;

        .durationTime {
          min-width: 100px;
          height: 20px;
          font-size: 14px;
          line-height: 20px;
        }
        .progresBar {
          position: relative;
          overflow: hidden;
          width: 166px;
          height: 8px;
          background-color: rgba(255, 255, 255, .3);
          border-radius: 4px;
          &.short {
            width: 136px;
          }
          .bar {
            position: absolute;
            top: 0;
            left: 0;
            width: 4px;
            height: 8px;
            background-color: #fff;
            border-radius: 4px;
          }
        }
      }
    }

    .loadingData {
      position: absolute;
      top: 2px;
      left: 2px;
      z-index: 100;
      width: calc(100% - 2px);
      height: calc(100% - 2px);
      background: #fff;
      border-radius: 6px;

       > span {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 50px;
        height: 50px;
        margin: auto;
        color: #d9ddea;
        font-size: 50px;
      }
    }

    .itemTitle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 20px;
      text-align: left;

      & .detail {
        color: #5778fb;
        text-decoration: underline;
      }
    }

    .iteamlottie {
      position: relative;
      overflow: hidden;
      width: 67px;
      height: 70px;
      margin-top: 5px;
      background: #f6f6fa;
      border: 2px solid #fff;
      border-radius: 3px;

      &:hover {
        border-color: #5778fb;
        img {
          opacity: 0;
        }
      }

      .Clottie {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 50px;
      }

      img {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        z-index: 0;
        width: auto;
        height: 50px;
        margin: auto;
        opacity: 1;
      }
      .title {
        position: absolute;
        right: 0;
        bottom: -2px;
        left: 0;
        z-index: 0;
        // width: 40px;
        height: 18px;
        margin: auto;
        font-size: 12px;
        border-radius: 5px;
      }
    }

    .iteamVideo,
    .iteamImg {
      position: relative;
      width: 280px;
      height: 157px;
      background-color: #ccc;

       > video,
       > img {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 0;
        width: auto;
        max-width: 100%;
        height: auto;
        max-height: 100%;
        margin: auto;
      }
    }
    .settingBtn {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      width: 280px;
      height: 45px;
      color: #474261;
      font-size: 14px;
      font-stretch: normal;
      font-weight: normal;
      line-height: 40px;
      letter-spacing: 0;

      .Sbtn {
        width: 138px;
        height: 40px;
        background-color: #f0f0f8;
        cursor: pointer;
        &:hover {
          .modifySprite {
            background: url("../../../../static/svg/videoSetting1.svg")
            no-repeat center;
            background-size: 18px auto;
          }

          .modifyBg {
            background: url("../../../../static/svg/videoBg1.svg") no-repeat
            center;
            background-size: 18px auto;
          }
        }
        .modifyBg,
        .modifySprite {
          display: inline-block;
          width: 18px;
          height: 18px;
          margin-right: 5px;
          font-size: 20px;
        }
        .modifySprite {
          vertical-align: text-bottom;
          background: url("../../../../static/svg/videoSetting0.svg") no-repeat
          center;
          background-size: 18px auto;
        }
        .modifyBg {
          vertical-align: text-bottom;
          background: url("../../../../static/svg/videoBg0.svg") no-repeat
          center;
          background-size: 18px auto;
        }
      }
    }

    .iteamImg {
      .delBtn {
        position: absolute;
        right: 10px;
        bottom: 10px;
      }
    }
    .vectorLottie {
      position: relative;
      width: 280px;
      height: 157px;
      background-color: #ccc;

      .vectorLottieContainer {
        position: absolute;
        top: 0;
        left: 0;
        width: auto;
        height: 100%;
      }

      .delBtn {
        position: absolute;
        right: 10px;
        bottom: 10px;
      }
    }
  }
}
.slide-fade-enter-active {
  // pointer-events: none;
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1, .5, .8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(30px);
  opacity: 0;
}

.vol {
  width: 16px;
  height: 16px;
  background-image: url(../../../../static/svg/sound-white.svg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  &.off {
    background-image: url(../../../../static/svg/no-sound-white.svg);
    // D:\work\laihua-tool\src\components\popups\secondPopups\charactersSprite.vue
    // D:\work\laihua-tool\static\svg\no-sound-white.svg
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/secondPopups/charactersSprite.vue